module.exports = __webpack_public_path__ + "img/icone-color.ebf3a2ad.png";